module.exports = __webpack_public_path__ + "static/0318_mobile-3be1371a008abb0f03517db20036e6c5.webp";